export default {
    "preview": {
        "noDocumentDataErrorPopupTitle": "Error loading document's data",
        "highlightsTitle": "Highlights",
        "noEntityToHighlight": "No highlighted entity in document",
        "termXLabel": "Search term {index, number}",
        "otherTerms": "Other terms",
        "previousDocument": "Previous",
        "nextDocument": "Next",
        "originalDocument": "Original document",
        "selectedHighlight": "Selected highlight",
        "noSelectedHighlight": "No highlight selected",
        "firstHighlightButtonAltText": "First",
        "previousHighlightButtonAltText": "Previous",
        "nextHighlightButtonAltText": "Next",
        "relevanceSortHighlightButtonText": "Relevance",
        "textOrderSortHighlightButtonText": "Text order",
        "lastHighlightButtonAltText": "Last",
        "highlightFilters": {
            "title": "Filters",
            "keepAll": "All",
            "keepNone": "None",
            "keepAllInCategory": "All",
            "keepNoneInCategory": "None"
        },
        "documentPropertiesTitle": "Details",
        "similarDocumentsTitle": "Similar documents",
        "showAll": "Show all values",
        "sortAlphabetically": "Sort alphabetically",
        "sortFrequency": "Sort by frequency",
        "loading": "Loading...",
        "noextract": "No extract",
        "search": "Search",
        "gotopage": "Go to page",
        "page": "Page {page}",
        "current": "current"
    },
    "facet": {
        "preview": {
            "closeTitle": "Close",
            "expandTitle": "Maximize",
            "minimize": "Zoom out",
            "maximize": "Zoom in",
            "toggleExtracts": "Toggle relevant extracts highlighting",
            "extracts": "Relevant Extracts",
            "toggleEntities": "Toggle entities highlighting",
            "entities": "Entities",
            "passages": "Relevant Passages",
            "showPassages": "Show/hide passages extracted by Neural Search",
            "downloadPdf": "Download PDF version",
            "viewPreview": "Preview",
            "viewPassages": "Passages",
            "documentPreview": "Document preview",
            "documentPreviewTitle": "This is the document preview",
            "documentPreviewDescription": "Click on one of your search results to preview the document here."
        }
    }
};
